module.exports = __webpack_public_path__ + "static/media/ring.99013af2.mp3";